import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Fade from 'react-reveal/Fade'
import awpData from './data'
import Results from './results'
import AddClapbackForm from './clapbackForm'
import './clapbacks.css'

const width = window.innerWidth;

class ClapbackChest extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data : [],
			searchActive : false,
			x: 0,
			intro:[],
			searchValue: null,
			results: null,
			activeResult: null,
			addClapback: false
		};
		this.searchFormRef = React.createRef();
	}

	componentDidMount() {
		this.getData();
		document.title = "BSA: Clapback Chest";
		setTimeout(() => {
			this.setState({
				x: width
			})
		}, 300);
	}

	componentWillUnmount() {
		this.setState({
			x: 0
		})
	}

	getData = () => {
		// let keywords = [];
		fetch('/api/clap-intro')
        .then(res => res.json())
        .then(data=> this.setState({ intro: data.about, data:data.data}));
		// const data = awpData;
		// this.setState({ data });
	}

	handleChange = (e) => {
		let element = e.target;
		let val = element.value;

		if (val.length > 2) {
			let results = this.state.data.filter((item) => {
				return item.title.toLowerCase().includes(val.trim().toLowerCase())
			});
			
			results.length ?
				this.setState({ results })
			:
				this.setState({ results: [] })
			;
		} else {
			this.setState({ results: null });
		}
	}

	handleFormClick = (e) => {
		// const el = e.target;
		// this.searchFormRef.current.scrollIntoView({behavior: "smooth"});

		// set searchActive to true
		// setTimeout(() => {
      this.setState({ searchActive: true }); 
    // }, 1000);
	}

	handleSubmit = (e) => {
		e.preventDefault();
	}

	hasResults = () => {
		const { results } = this.state;
		return results && results.length > 0 && `hasResults`
	}

	toggleForm = () => {
    const formActive = this.state.addClapback;
    this.setState({addClapback: !formActive});
  }

  closeModal = () => {
  	this.setState({
  		activeResult: null,
			addClapback: false
  	})
  }

  handleActiveResult = (result) => {
    this.setState({activeResult: result});
    const activeResultElement = document.getElementsByClassName("clapback-modal")[0];
    activeResultElement.scrollTop = 0;
  }

	render() {
		const { 
			data,
			x,
			results,
			addClapback,
			activeResult,
			searchActive,
			intro
		} = this.state;

		return (
			<div id="awpHolder" style={{
				height: `100%`, 
				position: `absolute`, 
				top: 0, 
				right: `-${width}px`,
				transform: `translateX(-${x}px)`,
				transition: 'transform .5s',
			}}>
				<React.Fragment>
					{data.length && intro.length ? (
						<div id="awp" className={ "bgWhite blkT fullWidth fullHeight" + (searchActive ? " searchActive" : "")}>
							<div className="clapback-head">
								<h1 className="oneColumnPush">BSA's Clapback Chest  <span className="withReceipts">(with receipts)</span></h1>
							</div>

							<div className={"clapback-modal" + (addClapback || activeResult ? " active" : "") + (activeResult ? "ResultModal" : "")}>
								<div className="closeX" onClick={this.closeModal.bind(this)}>
									<span></span>
									<span></span>
								</div>
								{addClapback ? (
									<Fade opposite when={addClapback}>
										<AddClapbackForm isActive={this.toggleForm} />
									</Fade>
								):("")}
								{activeResult ? (
									<Fade>
										<div className="activeResult">
											<h2 className="claim marginBotTiny">{activeResult.title}</h2>
											{activeResult.name?(
												<p className="submited numeroText marginBotSmall">Submitted by: <span className="boldT resourceAuthor">{activeResult.name}</span></p>
											):('')}
											
											<div className="response marginTopSmall" dangerouslySetInnerHTML={{ __html : activeResult.response }}></div>
										</div>
									</Fade>
								):("")}
							</div>

							<div className={`${(addClapback || activeResult) && 'modalActive'} ${this.hasResults()} clapback-ui`}>
								<div className="search-select">
									<form id="awpSearch" ref={this.searchFormRef} className="tfStage oneColumnPush" method="GET" name="search" onClick={this.handleFormClick} onSubmit={this.handleSubmit}>
										<input id="awpSearchBar" autoComplete="on" className="searchField center" name="search" type="text" onChange={this.handleChange} placeholder="Enter ignorance here"></input>
									</form>
									<div id="awpResultsUL" className={`${this.hasResults()} awpSearchResults`}>
										<Results data={results} handleActive={this.handleActiveResult}/>
									</div>
									<div className="explainer oneColumnPush tfStage" dangerouslySetInnerHTML={{ __html : intro[0].clapText }}>
										
									</div>
								</div>
								<Fade>
									<div className="submit-clapback">
										<h4>Have a Prompt or Response to Throw into the Clapback Chest?</h4>
										<p style={{fontStyle: 'italic'}}>Most of the prompts and responses in BSA’s Clapback Chest were sourced directly from the global Left community. If you have suggestions for prompts, responses, corrections, or additions to what’s already there, please submit them to us <span className="smMobile" onClick={this.toggleForm.bind(this)}>here</span>.</p>
										<div className="submit-clapback-button buttonCTA buttonText" onClick={this.toggleForm.bind(this)}>
											<p>SUBMIT</p>
										</div>
									</div>
								</Fade>
							</div>
						</div>
					):("")}
				</React.Fragment>
			</div>
		)
	}
}

export default ClapbackChest;



// WEBPACK FOOTER //
// ./src/components/resources/awp/clapbacks.js